import { render, staticRenderFns } from "./Importation.vue?vue&type=template&id=3fa56070&scoped=true&"
import script from "./Importation.vue?vue&type=script&lang=js&"
export * from "./Importation.vue?vue&type=script&lang=js&"
import style0 from "./Importation.vue?vue&type=style&index=0&id=3fa56070&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa56070",
  null
  
)

export default component.exports